import { CSSProperties } from 'react'
import styled from 'styled-components'

const readable = (date: string, lang: 'de' | 'fr') =>
  new Date(date).toLocaleDateString(lang === 'de' ? 'ch-DE' : 'fr-FR', {
    month: 'long',
    day: 'numeric'//,year:"numeric"
  })

export const PointMarker = ({
  x,
  y,
  r = 10,
  style,
  value,
  date,
  position = 'right',
  lang = 'de',
}: {
  x: number
  y: number
  r?: number
  style?: CSSProperties
  value?: number
  date?: string
  lang?: 'de' | 'fr'
  position?: 'left' | 'right'
}) => {
  let eng = date && new Date(date) < new Date('2022-03-01')
  let sehreng = date && new Date(date) > new Date('2022-09-01')
  let xMove = eng ? 20 : sehreng ? 70 : 40
  if (position === 'left') xMove = -xMove

  let xPos = x + xMove

  return (
    <>
      <MarkerLine x1={1000} x2={0} y1={y} y2={y} />
      {value && (
        <>
          <MarkerText
            x={xPos}
            y={y + 22}
            textAnchor={position === 'left' ? 'end' : 'start'}
            fontWeight={700}
            fill='var(--red-main)'
          >
            {value} Fr.
          </MarkerText>
        </>
      )}
      {date && (
        <>
          <MarkerText
            x={xPos}
            y={y - 10}
            textAnchor={position === 'left' ? 'end' : 'start'}
            fontSize={13}
            fill='var(--text-color)'
          >
            {readable(date,lang)}
          </MarkerText>
        </>
      )}
      <MarkerCircle cx={x} cy={y} r={r} />
    </>
  )
}

const MarkerCircle = styled.circle`
  fill: var(--red-main);
  stroke: var(--site-background);
  stroke-width: 2;
`
const MarkerLine = styled.line`
  stroke: var(--red-main);
  stroke-width: 3px;
  stroke-dasharray: 0 6;
  stroke-linecap: round;
  stroke-linejoin: round;
`
const MarkerText = styled.text`
  fill: var(--red-main);
`
